/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useReasonForVisit } from "../../../services/reason-for-visit/reason-for-visit.service";
import { CentralLoadingIndicator, PetAvatars } from "../../../components";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import ReasonForVisitCardList from "../../modals/ExpressServiceUpsellModal/ReasonForVisitCardList";
import { Box } from "@mui/material";
import DoctorVisitToggleCard from "./DoctorVisitToggleCard";
import { useReasonForVisitV2 } from "../../../services/reason-for-visitV2/reason-for-visit.service-v2";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { userActivityLogger } from "../../../utils/mixpanel";

interface IExpressReasonForVisitContainer {
reasonUpdatePetIndex: number
setIsLoading?: (isLoading: boolean) => void;
selectedReasons: string[];
setSelectedReasons: (reason: string[]) => void;
setActiveStep: (step: number) => void;
setReasonUpdatePetIndex: (index: number) => void;
}

const ExpressReasonForVisitContainer = ({
  reasonUpdatePetIndex,
  setIsLoading,
  selectedReasons,
  setSelectedReasons,
  setActiveStep,
  setReasonUpdatePetIndex,
}: IExpressReasonForVisitContainer) => {
  const { expressReasonList, loading } = useReasonForVisitV2();
  const { selectedPets, reasonForVisit } = useAppointmentStore();
  const petAvatarRef = useRef<HTMLDivElement>(null);


  const onReasonSelection = (reason: string) => {
    const newSelectedReasons = selectedReasons.includes(reason) ?
      selectedReasons.filter((r) => r !== reason) :
      [...selectedReasons, reason];

    setSelectedReasons(newSelectedReasons);
  };

  const handleToggle = ()=>{
    setReasonUpdatePetIndex(1);
    setActiveStep(3);
  };

  const formatReasonPetNames = (bookingPetsName: string[])=>{
    if (!Array.isArray(bookingPetsName) || bookingPetsName.length === 0) return "";

    if (bookingPetsName.length === 1) {
      return `${bookingPetsName[0]}`;
    } else if (bookingPetsName.length === 2) {
      return `${bookingPetsName[0]} and ${bookingPetsName[1]}`;
    } else if (bookingPetsName.length === 3) {
      return `${bookingPetsName[0]}, ${bookingPetsName[1]} and ${bookingPetsName[2]}`;
    }

    return "";
  };

  useEffect(() => {
    if (petAvatarRef.current) {
      petAvatarRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [reasonUpdatePetIndex]);


  useEffect(()=>{
    setIsLoading && setIsLoading(loading);
  }, [loading]);

  useEffect(()=>{
    userActivityLogger(MIXPANEL_EVENTS.EXPRESS_SERVICE_SELECT_PET, {
      appointment_category: "tech",
      pet_name: selectedPets.map((pet) => pet.name).join(","),
      no_of_pets: selectedPets.length,
    });
  }, []);

  return (
    <div className="w-full flex flex-col gap-4 p-4 border border-taupe-50 rounded-xl ">
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-1">
          <div className="text-lg">
            Which of these does&nbsp;
            <span className="font-semibold">{formatReasonPetNames([selectedPets[reasonUpdatePetIndex - 1].name])}
            </span>  need?
          </div>
          <div className="text-sm text-gray-1">Select all that apply.</div>
        </div>
        <div ref={petAvatarRef}>
          <PetAvatars
            height={50}
            width={50}
            petDetails={[selectedPets[reasonUpdatePetIndex-1]]} />
        </div>
      </div>
      {loading ?
        <CentralLoadingIndicator /> :
        <div className="flex flex-col gap-3">
          <ReasonForVisitCardList
            selectedReasons={selectedReasons}
            reasonsList={expressReasonList.flatMap((category) => category.options)}
            onReasonSelection={onReasonSelection} />
          <Box className="border-b-2 border-gray-3 w-full"></Box>
          <DoctorVisitToggleCard handleToggle={handleToggle} />
        </div>}
    </div>
  );
};

export default ExpressReasonForVisitContainer;
